import { useEffect, useState } from 'react';
import {
  getMaxSizeAndPos,
  getTopAndBottomSectionSum,
} from '../../sections/utils';
import { SectionsState } from '../../sections/types';
import { useAppSelector } from '../../core/hooks/storeHooks';

export default () => {
  const sections: SectionsState = useAppSelector((state) => state.sections);
  const [masterWinSize, setMasterWinSize] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [maxSize, setMaxSize] = useState({
    height: 0,
    width: 0,
  });

  useEffect(() => {
    const maxDims = getMaxSizeAndPos(sections);
    setMaxSize({ height: maxDims.height, width: maxDims.width });
  }, [sections, masterWinSize]);

  useEffect(() => {
    const handleResize = () => {
      setMasterWinSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      // const maxDims = getMaxSizeAndPos(sections);
      // setMaxSize({ height: maxDims.height, width: maxDims.width })
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // const limits = getWindowMaxLimits(sections, masterWinSize);
  const { topSectionSum, bottomSectionSum } =
    getTopAndBottomSectionSum(sections);

  return {
    topSectionSum,
    bottomSectionSum,
    maxSize,
  };
};
